import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router/index.js'

export const login = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/index.php', payload)
    .then(res => {
        if(res.data.status) {
            dispatch('storeAuthResponse', {data: res.data, goHome: true})
        } else {
            alert('Error de inicio de sesion')
        }

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const changePassword = ({commit, dispatch}, payload) => {

    axios.post('/customerPortal/changePassword.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            dispatch('logout')
        } else {
            alert(res.data.message)
        }
        

    })
    .catch(error => {
        console.log(error)
    })
    
}

export const storeAuthResponse = ({commit, dispatch}, payload) => {

    commit('setUserauthResponse', payload.data)
    if(payload.goHome) {
        window.location = '/'
        if(payload.data.read_only_customer_login === 1) {
            router.push('guests')
        }        
    } else {
        if(payload.data.read_only_customer_login === 1) {
            router.push('guests')
        }
    }
}
export const tryAutoLogin = ({commit, dispatch}) => {

    const accessToken = localStorage.getItem('accessToken')
    
    if(!accessToken) {
        return 
    }
    
    const postData = {access_token: accessToken}
    
    axios.post('/customerPortal/autoLogin.php', postData)
    .then(res => {

        if(res.data.status) {        
            dispatch('fetchEventProfileInfo')
            dispatch('fetchFoodMenuLists')
            dispatch('fetchSubMenus')
            dispatch('fetchRecipe')
            commit('toggleEventButtonLoading', false)
            dispatch('fetchTableList')
            dispatch('fetchTableClothList')
            dispatch('fetchCakeList')
            dispatch('fetchEventType')
            dispatch('storeAuthResponse', {data: res.data, goHome: false})
        } else {
            dispatch('logout')
        }

    })
    .catch(error => {
       
    })
    
}

export const logout = ({commit}) => {
    console.log("Here-Logout")
    commit('clearAuthData')        
    /*axios.get('/customerPortal/logout.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('clearAuthData')        
    })
    .catch(error => {
        console.log(error)
        commit('setAlertBox', {title: 'Error', message: 'Error: ¡Inténtalo de nuevo!'})                
    })*/
    
}

export const downloadPDF = ({}, payload) => {
    const prtHtml = document.getElementById(payload.portId).innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
            }

            var iframe = document.createElement('iframe');
            iframe.style.display = "none";

            var html = `<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body style="margin:0; overflow:hidden;">
                ${prtHtml}
            </body>
            </html>`;
            document.body.appendChild(iframe);
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(html);
            //iframe.contentWindow.document.close();
            
            iframe.contentWindow.print();
            iframe.contentWindow.document.close();

            
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js